"use client";
import CTALink from "@/components/CTA/ctaLink";
import React from "react";
import { hyphenateForTagular } from "@/utils/tagular/helpers";
import useTranslations from "@/i18n/useTranslations";

type Props = {
  courseName: string;
};

function BusinessBlock({ courseName }: Props) {
  const t = useTranslations("Course");
  return (
    <div className="container md:pb-8 lg:py-0">
      <div className="flex flex-wrap">
        <div className="w-full lg:w-3/12 relative">
          <div className="relative lg:py-[50px] lg:w-[300px]">
            <h2 className="text-primary-500 md:mb-4 lg:mr-4 text-[2.25rem] lg:text-2xl leading-[2.5rem] hidden md:block">
              {t("interestedInCourseBusinessTeam")}
            </h2>
            <span className="lg:absolute lg:top-0 lg:right-[-23px] lg:bottom-0 lg:w-[500%] bg-putty-200 transform -skew-x-6 z-[-1] hidden lg:block"></span>
          </div>
        </div>
        <div className="w-full lg:w-9/12 flex flex-col justify-center text-primary-500">
          <div className="text-base lg:ml-[114px]">
            {t("trainEmployeesEdxForBusiness")}
            <div className="flex flex-col sm:flex-row mt-4 w-full space-y-2 sm:space-y-0 sm:space-x-2">
              <CTALink
                label={t("requestInformation")}
                url="https://business.edx.org/business/book-demo?utm_medium=WebReferral&utm_source=edX&utm_campaign=edXCoursePage"
                radius="default"
                className="bg-primary border border-primary hover:bg-[#2d494e] text-white hover:text-white mr-2 w-full sm:w-auto rounded-full"
                size="lg"
                location="enterprise-solutions-asset"
                html_id="request-info-CTA"
                name={hyphenateForTagular(courseName)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessBlock;
